<div class="page-wrap height-100 black">
  <div class="session-form-hold">
    <mat-progress-bar mode="determinate" class="session-progress"></mat-progress-bar>
    <mat-card>
      <mat-card-content>
        <!-- Language Switcher -->
        <div class="session-language-select">
          <language-switcher></language-switcher>
        </div>
        <div class="text-center pt-8 pb-16">
          <img width="60px" src="assets/images/logo-lg.png" alt="" class="mb-05">
           <h2>{{ 'Lets get started' | translate }}</h2>
          <p *ngIf="!(hasAdmin$ | async)" class="text-muted m-0">{{ 'Sign up to use the service' | translate }}</p>
          <p *ngIf="hasAdmin$ | async" >Please, contact domain administrator to get your account information before using the service</p>
        </div>
        <form *ngIf="!(hasAdmin$ | async)" [formGroup]="signupForm"  (ngSubmit)="signup()">
          <div class="">
            <mat-form-field class="full-width">
              <input id="email" matInput type="email" formControlName="email" placeholder="{{ 'Your Email' | translate }}">
            </mat-form-field>
            <mat-error *ngIf="signupForm.controls['email'].hasError('required') && signupForm.controls['email'].touched"
                       class="form-error-msg-large">{{ 'Email is required' | translate }}</mat-error>
            <mat-error *ngIf="signupForm.controls['email'].hasError('pattern') && signupForm.controls['email'].touched"
                       class="form-error-msg-large">{{ 'Invaild email address' | translate }}</mat-error>
            <mat-error *ngIf="emailErrMsg && !signupForm.controls['email'].dirty"
                        class="form-error-msg-large">{{ 'User with that E-mail already exists!' | translate }}</mat-error>
          </div>

          <div class="">
            <mat-form-field class="full-width">
              <input id="password" type="password" formControlName="password" matInput placeholder="{{ 'Password' | translate }}">
            </mat-form-field>
            <mat-error *ngIf="signupForm.controls['password'].hasError('required') && signupForm.controls['password'].touched"
                       class="form-error-msg-large"> {{ 'Password is required' | translate }} </mat-error>
          </div>
          
          <div class="">
            <mat-form-field class="full-width">
              <input id="confirm-password" type="password" formControlName="confirmPassword" matInput placeholder="{{ 'Confirm password' | translate }}">
            </mat-form-field>
            <mat-error *ngIf="signupForm.controls['confirmPassword'].hasError('required') && signupForm.controls['confirmPassword'].touched" class="form-error-msg-large">{{ 'Confirm password is required' | translate }}</mat-error>
            <mat-error *ngIf="signupForm.controls['confirmPassword'].hasError('equalTo')" class="form-error-msg-large">{{ 'Passwords do not match' | translate }}</mat-error>
          </div>
          
          <div class="pb-1">
            <mat-checkbox id="terms-checkbox" formControlName="agreed" class="pb-1" [disableRipple]="true">{{ 'I have read and agree to the' | translate }}
              <a style="color: #069" href="https://teamtrackerhq.com/license">{{ 'terms of service' | translate }}</a>.
            </mat-checkbox>
              <mat-error
                *ngIf="signupForm.controls['agreed'].hasError('required') && signupForm.controls['agreed'].touched"
                class="form-error-msg-large">{{ 'You must agree to the terms and conditions' | translate }}</mat-error>
          </div>

          <div class="pb-1">
            <mat-checkbox formControlName="rememberMe" class="pb-1" [disableRipple]="true">{{ 'Remember this computer' | translate }}</mat-checkbox>
          </div>

          <button id="user-sign-up-button" mat-raised-button class="mat-primary full-width mb-1" [disabled]="signupForm.invalid">{{ 'Sign up' | translate }}</button>
        </form>
        <div class="text-center">
          <a [routerLink]="'/sessions/signin_user'" class="text-center full-width">{{ 'Sign in to existing account' | translate }}</a>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</div>
